import { render, staticRenderFns } from "./FormTextarea.vue?vue&type=template&id=b98b6464&functional=true"
import script from "./FormTextarea.vue?vue&type=script&lang=js"
export * from "./FormTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/serbanhoratiutudor/Projects/genie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b98b6464')) {
      api.createRecord('b98b6464', component.options)
    } else {
      api.rerender('b98b6464', component.options)
    }
    module.hot.accept("./FormTextarea.vue?vue&type=template&id=b98b6464&functional=true", function () {
      api.rerender('b98b6464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/core/FormTextarea.vue"
export default component.exports